(function () {
  function getThumbnailButtons(gallery) {
    return Array.from(
      gallery.querySelectorAll('.thumbnail-slider .thumbnail[aria-controls^="GalleryViewer-"]')
    );
  }

  function getCurrentIndex(thumbnails) {
    const current = thumbnails.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
    return current >= 0 ? current : 0;
  }

  function updateDesktopArrowState(gallery) {
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const prev = viewer?.querySelector('.slider-buttons .slider-button--prev');
    const next = viewer?.querySelector('.slider-buttons .slider-button--next');
    if (!viewer || !prev || !next) return;

    if (window.innerWidth < 990) {
      prev.setAttribute('disabled', 'disabled');
      next.setAttribute('disabled', 'disabled');
      return;
    }

    const thumbnails = getThumbnailButtons(gallery);
    if (!thumbnails.length) {
      prev.setAttribute('disabled', 'disabled');
      next.setAttribute('disabled', 'disabled');
      return;
    }

    const currentIndex = getCurrentIndex(thumbnails);
    if (currentIndex <= 0) {
      prev.setAttribute('disabled', 'disabled');
    } else {
      prev.removeAttribute('disabled');
    }

    if (currentIndex >= thumbnails.length - 1) {
      next.setAttribute('disabled', 'disabled');
    } else {
      next.removeAttribute('disabled');
    }
  }

  function bindDesktopGalleryArrows(gallery) {
    if (!gallery || gallery.dataset.caseittDesktopGalleryBound === 'true') return;

    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const prev = viewer?.querySelector('.slider-buttons .slider-button--prev');
    const next = viewer?.querySelector('.slider-buttons .slider-button--next');
    if (!viewer || !prev || !next) return;

    function move(direction, event) {
      if (window.innerWidth < 990) return;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }

      const thumbnails = getThumbnailButtons(gallery);
      if (!thumbnails.length) return;

      const currentIndex = getCurrentIndex(thumbnails);
      const targetIndex = Math.max(0, Math.min(thumbnails.length - 1, currentIndex + direction));
      if (targetIndex === currentIndex) {
        updateDesktopArrowState(gallery);
        return;
      }

      thumbnails[targetIndex].click();

      window.requestAnimationFrame(() => {
        setTimeout(() => {
          thumbnails[targetIndex]?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          updateDesktopArrowState(gallery);
        }, 40);
      });
    }

    prev.addEventListener('click', function (event) {
      move(-1, event);
    }, true);

    next.addEventListener('click', function (event) {
      move(1, event);
    }, true);

    gallery.addEventListener('click', function (event) {
      if (event.target.closest('.thumbnail')) {
        setTimeout(() => updateDesktopArrowState(gallery), 30);
      }
    });

    const observer = new MutationObserver(function () {
      updateDesktopArrowState(gallery);
    });

    observer.observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current']
    });

    window.addEventListener('resize', function () {
      updateDesktopArrowState(gallery);
    });

    gallery.dataset.caseittDesktopGalleryBound = 'true';
    setTimeout(() => updateDesktopArrowState(gallery), 60);
  }

  function initCaseittDesktopGalleries(scope) {
    (scope || document).querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(bindDesktopGalleryArrows);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCaseittDesktopGalleries(document);
    setTimeout(() => initCaseittDesktopGalleries(document), 250);
  });

  document.addEventListener('product-info:loaded', function (event) {
    initCaseittDesktopGalleries(event.target.closest('product-info') || document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCaseittDesktopGalleries(event.target);
  });
})();
